import { render, staticRenderFns } from "./DmsBatchTables.vue?vue&type=template&id=9f1a4594&scoped=true&"
import script from "./DmsBatchTables.vue?vue&type=script&lang=js&"
export * from "./DmsBatchTables.vue?vue&type=script&lang=js&"
import style0 from "./DmsBatchTables.vue?vue&type=style&index=0&id=9f1a4594&scoped=true&lang=css&"
import style1 from "./DmsBatchTables.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1a4594",
  null
  
)

export default component.exports